<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="GiftList" 
          :extra-items="['贈品兌換紀錄']"
        />
      </div>
    </div>
    <b-card>
      <RedeemLog />
    </b-card>
  </div>
</template>

<script>
import RedeemLog from "@/components/Dashboard/PointLog/RedeemLog.vue"
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    RedeemLog,
    BreadCrumb
  },
};
</script>
